import React from "react";
import DashboardMarketSelect from "./DashboardMarketSelect";
import "./DashboardMarketSelectBar.css";

const DashboardMarketSelectBar = ({ className = "" }) => (
  <div
    className={`dashboardMarketSelectBar${className ? ` ${className}` : ""}`}
  >
    <DashboardMarketSelect />
  </div>
);

export default DashboardMarketSelectBar;
